import React from 'react';
export function Footer() {
  return <footer className="bg-white py-16 border-t border-slate-100" data-id="element-1782">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1783">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-16" data-id="element-1784">
          <div className="col-span-2 lg:col-span-2" data-id="element-1785">
            <div className="flex items-center gap-2 mb-6" data-id="element-1786">
              <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center" data-id="element-1787">
                <div className="w-3 h-3 border-2 border-white rounded-full border-t-transparent transform rotate-45" data-id="element-1788"></div>
              </div>
              <span className="font-bold text-2xl tracking-tight text-slate-900" data-id="element-1789">
                openmart
              </span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed max-w-xs mb-6" data-id="element-1790">
              The premier local business data API, local business API, and
              Google Places API alternative. A powerful local business search
              API for modern data teams.
            </p>
            <div className="flex space-x-4" data-id="element-1791">
              <a href="#" className="text-slate-400 hover:text-blue-600 transition-colors" data-id="element-1792">
                <span className="sr-only" data-id="element-1793">Twitter</span>
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-1794">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-1795" />
                </svg>
              </a>
              <a href="#" className="text-slate-400 hover:text-blue-600 transition-colors" data-id="element-1796">
                <span className="sr-only" data-id="element-1797">LinkedIn</span>
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-1798">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-1799" />
                </svg>
              </a>
            </div>
          </div>

          <div data-id="element-1800">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1801">Features</h4>
            <ul className="space-y-3" data-id="element-1802">
              <li data-id="element-1803">
                <a href="#/local-business-api" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1804">
                  Local business API
                </a>
              </li>
              <li data-id="element-1805">
                <a href="#/google-maps-scraper" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1806">
                  Google Maps scraper
                </a>
              </li>
              <li data-id="element-1807">
                <a href="#/local-business-database" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1808">
                  Local business database
                </a>
              </li>
              <li data-id="element-1809">
                <a href="#/local-business-enrichment" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1810">
                  Data enrichment
                </a>
              </li>
              <li data-id="element-1811">
                <a href="#/owner-finder" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1812">
                  Owner finder
                </a>
              </li>
              <li data-id="element-1813">
                <a href="#/local-marketing" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1814">
                  Local marketing
                </a>
              </li>
              <li data-id="element-1815">
                <a href="#/email-sequencing" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1816">
                  Email sequencing
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-1817">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1818">Products</h4>
            <ul className="space-y-3" data-id="element-1819">
              <li data-id="element-1820">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1821">
                  Search
                </a>
              </li>
              <li data-id="element-1822">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1823">
                  Enrich
                </a>
              </li>
              <li data-id="element-1824">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1825">
                  Engage
                </a>
              </li>
              <li data-id="element-1826">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1827">
                  API
                </a>
              </li>
              <li data-id="element-1828">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1829">
                  Integrations
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-1830">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1831">
              Industries
            </h4>
            <ul className="space-y-3" data-id="element-1832">
              <li data-id="element-1833">
                <a href="#/data/accounting" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1834">
                  Accounting
                </a>
              </li>
              <li data-id="element-1835">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1836">
                  Healthcare
                </a>
              </li>
              <li data-id="element-1837">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1838">
                  Home Services
                </a>
              </li>
              <li data-id="element-1839">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1840">
                  Retail
                </a>
              </li>
              <li data-id="element-1841">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1842">
                  Real Estate
                </a>
              </li>
              <li data-id="element-1843">
                <a href="#/data" className="text-slate-500 hover:text-blue-600 text-sm transition-colors font-medium" data-id="element-1844">
                  View all 300+
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-1845">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1846">Company</h4>
            <ul className="space-y-3" data-id="element-1847">
              <li data-id="element-1848">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1849">
                  About us
                </a>
              </li>
              <li data-id="element-1850">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1851">
                  Careers
                </a>
              </li>
              <li data-id="element-1852">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1853">
                  Blog
                </a>
              </li>
              <li data-id="element-1854">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1855">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-12" data-id="element-1856">
          <div className="col-span-2 lg:col-span-2" data-id="element-1857"></div>

          <div data-id="element-1858">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1859">Use Cases</h4>
            <ul className="space-y-3" data-id="element-1860">
              <li data-id="element-1861">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1862">
                  Sales Teams
                </a>
              </li>
              <li data-id="element-1863">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1864">
                  Marketing Agencies
                </a>
              </li>
              <li data-id="element-1865">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1866">
                  SaaS Companies
                </a>
              </li>
              <li data-id="element-1867">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1868">
                  Investors
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-1869">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1870">
              Comparisons
            </h4>
            <ul className="space-y-3" data-id="element-1871">
              <li data-id="element-1872">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1873">
                  vs Google Places
                </a>
              </li>
              <li data-id="element-1874">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1875">
                  vs Apollo
                </a>
              </li>
              <li data-id="element-1876">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1877">
                  vs ZoomInfo
                </a>
              </li>
              <li data-id="element-1878">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1879">
                  vs Yelp API
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-1880">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1881">Legal</h4>
            <ul className="space-y-3" data-id="element-1882">
              <li data-id="element-1883">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1884">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-1885">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1886">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-1887">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1888">
                  Cookie Policy
                </a>
              </li>
              <li data-id="element-1889">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1890">
                  DPA
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-100 flex flex-col md:flex-row justify-between items-center" data-id="element-1891">
          <p className="text-slate-400 text-sm" data-id="element-1892">
            © {new Date().getFullYear()} Openmart Inc. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-1893">
            <div className="flex items-center gap-2 text-sm text-slate-500" data-id="element-1894">
              <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-1895"></span>
              All systems operational
            </div>
          </div>
        </div>
      </div>
    </footer>;
}